import Registry from './models/Registry';
import Swup from 'swup';
import { createApp } from 'vue';
import archiveAppLogic from './components/ArchiveNews';

class App {
  constructor(context) {
    this.registry = new Registry();
    this.contextInstance = this.initController(context);
    this.vueInstance = null;
    this.swupEnabled = true; // Default true, configurabile

		this.initVueApp();
		// inzializzo vue qui perche altrimenti se ricarico la pagina non lo legge

    if (this.swupEnabled) {
      this.swup = this.initSwup();
      this.initSwupHooks();
			this.updateBodyClasses();
    }
  }

  initController(context) {
    const ContextClass = this.registry.getContext(context);
    const options = {
      lenisEnabled: true
    };

    return new ContextClass(options);
  }

  initSwup() {
    return new Swup({
      containers: ['#master'],
      cache: false,
			linkSelector: 'a[href]:not([href^="#"]):not([target]):not([download]):not([href^="mailto:"]):not([href^="tel:"])'
    });
  }

  initVueApp() {
    const archiveElement = document.getElementById('archive-news');
    if (archiveElement) {
      console.log('Trovato #archive-news, monto l\'app Vue...');
      this.vueInstance = createApp(archiveAppLogic);
      this.vueInstance.mount('#archive-news');
    }
  }

  destroyVueApp() {
    if (this.vueInstance) {
      this.vueInstance.unmount();
      this.vueInstance = null;
    }
  }

  initSwupHooks() {
    this.swup.hooks.on('content:replace', () => {
      this.updateBodyClasses(); // Prima aggiorna le classi del body
      this.contextInstance.reinit(); // Poi reinizializza i componenti (che ora vedranno le classi corrette)
      this.initVueApp();
    });

    this.swup.hooks.on('visit:start', () => {
      this.destroyVueApp();
      if (typeof this.contextInstance.cleanupBeforeTransition === 'function') {
        this.contextInstance.cleanupBeforeTransition();
      }
    });
  }

	updateBodyClasses() {
    const newBodyClassesEl = document.querySelector('#body-classes');
    if (newBodyClassesEl && newBodyClassesEl.dataset.bodyClasses) {
      const newBodyClasses = newBodyClassesEl.dataset.bodyClasses;
      document.body.className = newBodyClasses;

      // Gestisci anche le classi dell'header e nav per il transparent header
      const hasTransparentHeader = newBodyClasses.includes('header-trasparent');
      const header = document.querySelector('#header');
      const nav = document.querySelector('#header nav');

      if (hasTransparentHeader) {
        if (header) header.classList.add('transparent');
        if (nav) nav.classList.add('transparent');
      } else {
        if (header) header.classList.remove('transparent');
        if (nav) nav.classList.remove('transparent');
      }
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const context = typeof _gTheme_ !== 'undefined' ? _gTheme_ : {};
  new App(context);
});
